import React from 'react';
import StaffListItem from './StaffListItem';
import { staffMembersProp } from './shapes';
import { t } from '../../../../modules/infra/i18n';

const StaffList = ({ staffMembers }) => (
  <div className="c-table-with-sticky-header u-position-relative u-mb+">
    <div className="u-scrollable-visible">
      <div className="c-table-card c-table-new c-sticky-header u-no-shadow u-table-layout-fixed">
        <div className="c-table-card__head">
          <div className="c-table-card__cell c-label u-1/2">{t('barber:staff.list.username')}</div>
          <div className="c-table-card__cell c-label u-1/2">{t('barber:staff.list.kind')}</div>
        </div>
      </div>
      <div className="c-table-card c-table-new u-table-layout-fixed u--mt--">
        {staffMembers.map(staffMember => (
          <StaffListItem staffMember={staffMember} key={staffMember.id} />
        ))}
      </div>
    </div>
  </div>
);

StaffList.propTypes = {
  staffMembers: staffMembersProp.isRequired,
};

StaffList.defaultProps = {
  staffMembers: [],
};

export default StaffList;
